module.exports = __webpack_public_path__ + "img/lazio-logo-icon.aaa62ae4.png";